import { ApiResponse, zps_ea_war } from '../zps';
import axios from 'axios';

export type IDenomination = {
  index: number;
  value: number;
  type: number;
  weight: number;
};

export type ICurrencyValuesForm = {
  cid: number;
  gid: number;
  entid?: number;
  eid?: number;
  maxAmount: number;
  minAmount: number;
  decAmount: number;
};

export type ICurrency = {
  EURExchangeRate: number;
  USDExchangeRate: number;
  entid?: number;
  cid: number;
  gid?: number;
  decAmount?: number;
  maxAmount?: number;
  minAmount?: number;
  sid?: number;
  currencyStr: string;
  denominations: IDenomination[];
  description: string;
  factor: number;
  mc_value: number[];
  mc_valueType: number[];
  mc_valueWeight: number[];
  nBills: number;
  nCoins: number;
};

export type Currency = ICurrency;

export interface ICurrencyResponse extends ApiResponse {
  currencies: ICurrency[];
}

export const fetchCurrencies = (): Promise<ICurrencyResponse> => {
  return axios.get<ICurrencyResponse>(`${zps_ea_war}/currency`).then(res => res.data);
};
